import { useState, useCallback } from 'react';
import { TaskTemplate } from 'utils/types/taskTemplate';

export const useTemplateModal = () => {
  const [activeTask, setActiveTask] = useState<TaskTemplate | null>(null);
  const [isTaskTemplateModalOpen, setIsTaskTemplateModalOpen] = useState(false);

  const toggleTaskTemplateModal = useCallback(() => {
    setIsTaskTemplateModalOpen(!isTaskTemplateModalOpen);
  }, [isTaskTemplateModalOpen]);

  const openTaskForEdit = useCallback((task: TaskTemplate) => {
    setActiveTask(task);
    setIsTaskTemplateModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setActiveTask(null);
    setIsTaskTemplateModalOpen(false);
  }, []);

  return {
    activeTask,
    isTaskTemplateModalOpen,
    toggleTaskTemplateModal,
    openTaskForEdit,
    closeModal,
  };
};
